import { Button } from '@itarget/shared'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Checkbox,
  Icon,
  Tooltip,
  Typography,
} from '@material-ui/core'
import { useState } from 'react'
import { useStyles } from './style'
import { useTranslation } from './translation'

const AdherenceCampaign = ({
  campaignId,
  handleTerms,
  description,
  handleAdherenceCampaign,
}) => {
  const [checked, setChecked] = useState(false)
  const [stage, setStage] = useState('default')
  const [hasError, setHasError] = useState(false)
  const styles = useStyles()
  const translation = useTranslation()

  const handleCheckboxChange = (event) => {
    setHasError(false)
    const eventTargetChecked = event.target.checked
    setChecked(eventTargetChecked)
  }

  const onClickDeniedButton = () => {
    Promise.resolve(
      handleAdherenceCampaign({
        termsStatus: checked,
        adherence: 'N',
        campaignId,
      }),
    )
      .then(() => setStage('denied'))
      .catch((reason) => reason === 'term' && setHasError(true))
  }

  const onClickAllowedButton = () => {
    Promise.resolve(
      handleAdherenceCampaign({
        termsStatus: checked,
        adherence: 'S',
        campaignId,
      }),
    )
      .then(() => setStage('allowed'))
      .catch((reason) => reason === 'term' && setHasError(true))
  }

  const onClickConfirmButton = () => {
    setStage('finished')
  }

  const onClickTerms = () => {
    handleTerms?.({ campaignId })
  }

  if (stage === 'finished') return <></>

  return (
    <Accordion
      defaultExpanded
      data-testid="campaign"
      className={styles.container}
      data-campaign-id={campaignId}
    >
      <Tooltip title={`#${campaignId} - ${description}`} placement="top-start">
        <AccordionSummary
          className={styles.titleContainer}
          expandIcon={<Icon>arrow_drop_down</Icon>}
        >
          <Icon className={styles.titleIcon}>account_balance_wallet</Icon>
          <Typography className={styles.title}>{description}</Typography>
        </AccordionSummary>
      </Tooltip>
      <AccordionDetails className={styles.detailsContainer}>
        {stage === 'default' && (
          <>
            <Typography className={styles.message}>
              {translation.message}
            </Typography>
            <Box
              className={`${styles.checkboxContainer} ${hasError ? styles.error : ''}`}
            >
              <Checkbox
                value={checked}
                role="checkbox"
                data-testid={'accept-terms'}
                className={styles.checkbox}
                onClick={handleCheckboxChange}
              />
              <Typography
                onClick={onClickTerms}
                className={styles.checkboxLabel}
              >
                {translation.terms}
              </Typography>
            </Box>
            <Box className={styles.actionsContainer}>
              <Button
                testId="action deny-adherence"
                className={styles.deniedButton}
                onClick={onClickDeniedButton}
              >
                {translation.denied}
              </Button>
              <Button
                icon="done"
                testId="action allow-adherence"
                className={styles.allowedButton}
                onClick={onClickAllowedButton}
              >
                {translation.allowed}
              </Button>
            </Box>
          </>
        )}
        {stage !== 'default' && (
          <>
            <Typography className={styles.message}>
              {stage === 'allowed'
                ? translation.allowedMessage
                : translation.rejectedMessage}
            </Typography>
            <Box className={styles.actionsContainer}>
              <Button
                icon="done"
                testId="action confirm-understanding"
                className={styles.confirmButton}
                onClick={onClickConfirmButton}
              >
                {translation.confirm}
              </Button>
            </Box>
          </>
        )}
      </AccordionDetails>
    </Accordion>
  )
}

export default AdherenceCampaign
